var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37906 10.042C2.36741 8.19167 3.02954 6.4003 4.24186 5.00235C5.45417 3.6044 7.13379 2.69541 8.96718 2.44507C10.8006 2.19473 12.6624 2.62015 14.2051 3.64192C15.7478 4.66369 16.866 6.21196 17.3508 7.99771C17.8357 9.78345 17.6541 11.6846 16.8399 13.3463C16.0258 15.008 14.6348 16.3166 12.9265 17.0278C11.2183 17.739 9.30956 17.8043 7.55672 17.2114C5.80388 16.6185 4.32671 15.408 3.40096 13.8058",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38095 12.8571L4.7619 10H0L2.38095 12.8571Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42857,
    cy: 1.42857,
    r: 1.42857,
    transform: "matrix(-1 0 0 1 11.4297 8.57031)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultView);
export default __webpack_public_path__ + "static/media/default-view.72973c957c8155222112b60b3b71241f.svg";
export { ForwardRef as ReactComponent };